module.exports = __webpack_public_path__ + "images/feature/star-myportfolio-196eef69b80c285ce219edef6f272c92.jpg";